//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { proposalToVoid_fun, backByProposalNo_fun, proposalQueryList, deleteByProposalNo_fun, certificatePreview, proposalCallWriteBack_fun, proposalCallBack_fun, batchDeclaration, documentLogOut_fun, saveNewClause, proposalQueryDto, correctRecordQuery } from '@/api/policymanagement';
import { toThousands, num3_type_fun } from '../../libs/common';
import { getCountryList } from '@/utils/country';
import { cargoInsuranceDc, BASE, BASE_PATH, countCargoInsuranceDc } from '@/api/importedColdChain';
import { download, getExcelPath } from "@/api/baseDataManage";
import { queryliPeiData, getChilComList, getChilComList_police, getProductList, getCompanyList, getBaseCodeByCodeType } from '@/api/baseDate';
export default {
  name: 'policysearch',
  data: function data() {
    return {
      cargoInsuranceDc: true,
      forbidFastClickFlag: false,
      baseUrl: BASE + BASE_PATH,
      //1.申请电子保单同步方法是否返回结果 0没有返回过 1 返回过
      doPolicy1: 0,
      //2.申请电子保单轮询方法是否返回结果 0没有返回过 1 返回过
      doPolicy2: 0,
      //3.计时---毫秒数
      doPolicyCount: 0,
      //4.定时器
      isFlag: false,
      selectedArr: [],
      lists: {
        proposalNo: '',
        protocolNo: '',
        autonuclearType: '',
        documentType: ''
      },
      address_list: '',
      payAgent: {
        selectedAgent: '',
        agentName: '',
        // 代理点名称
        email: '',
        // 邮箱
        telephoneNumber: '',
        // 电话
        facsimileNumber: '' // 传真

      },
      newList: [],
      props: {
        label: 'label',
        value: 'value'
      },
      currentPage4: 4,
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: [],
      CIcredentials: false,
      permissionsbtn: true,
      agentShow: false,
      agentPrintShow: false,
      agentPrintTitle: '',
      agentPrint: {
        originalAmount: '3',
        copyAmount: '0'
      },
      quantitylList: [{
        label: '0',
        value: '0'
      }, {
        label: '1',
        value: '1'
      }, {
        label: '2',
        value: '2'
      }, {
        label: '3',
        value: '3'
      }, {
        label: '4',
        value: '4'
      }],
      previewFlag: false,
      value: '',
      agentOptions: [],
      tableData1: [{
        proposalNo: '',
        proposalStatus: '投保单状态',
        addRecordFlag: '是否自动申报待补录',
        riskCode: '险种代码',
        riskName: '险种名称',
        insuranceCompanyName: '保险公司',
        companyCode: '分支机构代码',
        companyName: '分支机构名称名称',
        policyHolderName: '投保人名称',
        insuredName: '被保险人名称',
        startDate: '起保日期',
        currency: '币别代码',
        currencyName: '币别代名称',
        amount: '保额',
        premium: '保费'
      }],
      options: [{
        value: '666666',
        label: '人民保险'
      }],
      options1: [{
        value: '1',
        label: '上海分公司'
      }],
      options2: [],
      options3: [{
        value: '1',
        label: '是'
      }],
      options4: [{
        value: '1',
        label: '待补录'
      }, {
        value: '2',
        label: '暂存'
      }, {
        value: '3',
        label: '已提交'
      }, {
        value: '4',
        label: '保险公司处理中'
      }, {
        value: '5',
        label: '保单生效'
      }, {
        value: '6',
        label: '保险公司审核不通过'
      }, {
        value: '7',
        label: '申报成功'
      }, {
        value: '9',
        label: '已退保'
      }, {
        value: '10',
        label: '已注销'
      }, {
        value: '11',
        label: '已撤回'
      }, {
        value: '12',
        label: '已作废'
      }, {
        value: '13',
        label: '保险公司批改审核中'
      }],
      options5: [{
        value: 'autoCustomFlag',
        label: '报关单自动投保'
      }, {
        value: 'customFlag',
        label: '报关单手动投保'
      }, {
        value: 'noCustom',
        label: '无报关单投保'
      }],
      inForm: {
        proposalNo: '',
        insuranceCompanyCode: '',
        //					insuranceCompanyCode: '666666',
        insuranceCompanyName: '',
        companyCode: '',
        companyName: '',
        riskCode: '',
        riskName: '',
        startDate: '',
        endDate: '',
        insuredName: '',
        addRecordFlag: '',
        proposalStatus: '',
        protocolNo: '',
        customsListNo: '',
        documentType: '',
        businessNo: '',
        downloadUrl: '',
        customFlag: '',
        user_type: '',
        policyNo: '',
        applicantName: ''
      },
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      agencybankrule: {
        selectedAgent: [{
          type: 'array',
          required: true,
          message: '请选择理赔代理点',
          trigger: 'change'
        }],
        agentName: [{
          required: true,
          message: '请输入代理点姓名',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱',
          trigger: 'blur'
        }],
        telephoneNumber: [{
          required: true,
          message: '请输入电话',
          trigger: 'blur'
        }],
        facsimileNumber: [{
          required: true,
          message: '请输入传真',
          trigger: 'blur'
        }]
      },
      agencyPrintrule: {
        originalAmount: [{
          required: true,
          message: '请选择正本数量',
          trigger: 'change'
        }],
        copyAmount: [{
          required: true,
          message: '请选择副本数量',
          trigger: 'change'
        }]
      },
      rulesSurrender: {
        reasonCode: [{
          required: true,
          message: '请选择批改原因',
          trigger: 'change'
        }],
        reasonText: [{
          required: true,
          message: '请输入退保原因',
          trigger: 'blur'
        }],
        reappearPolicyNo: [{
          required: true,
          message: '请输入重出保单号',
          trigger: 'blur'
        }, {
          pattern: /^[A-Za-z0-9]+$/,
          message: '请输入正确的保单号（字母+数字）',
          trigger: 'blur'
        }]
      },
      rules: {
        insuranceCompanyCode: [{
          required: false,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        riskCode: [{
          required: false,
          message: '请选择产品名称',
          trigger: 'change'
        }],
        addRecordFlag: [{
          required: false,
          message: '请选择自动申报补录',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      documentTypeOptions: [{
        value: '4',
        label: '已生成电子保单'
      }, {
        value: '5',
        label: '已生成CI凭证'
      }, {
        value: '1',
        label: '申请电子保单'
      }, {
        value: '2',
        label: '申请CI凭证'
      }],
      options_insuranceCompanyName: [],
      options_companyName: [],
      dialogVisible: false,
      endorseDataApplyInfo: [],
      endorseData: [],
      correctRecordList: [],
      isOrNotCI: false,
      insuredNameCheck: [],
      refundDialogVisible: false,
      checkRefundDialogVisible: false,
      showFooterBtn: true,
      refundForm: {
        reasonCode: '',
        reasonText: '',
        reappearPolicyNo: ''
      },
      currentRow: null
    };
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  mounted: function mounted() {// var as = getCountryList();
    // var city = [];
    //
    // as.forEach(function (data) {
    //   var cit = {'value':data.codeCode,'label':data.codeCname};
    //   city.push(cit);
    // });
    // this.agentOptions =city;
    // console.log('数组---',this.agentOptions)
  },
  created: function created() {
    this.getInsuredNameCheck();
    this.Init_get();
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = '';

    if (this.$store.state.user.userinfo.insuranceCompanyList.length !== 0) {
      companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    } // 不同角色用户登录进去保险公司数据源不同
    // 货运险注册用户：register insuranceCompanyList
    // 子账号被保险人用户：subAssured sainsuranceCompanyList
    // 货运险注册用户+子账号被保险人用户 两者合并


    var userRoleType = this.$store.state.user.userinfo.userRoleType;

    if (userRoleType !== null && userRoleType.includes('subAssured')) {
      var saList = this.$store.state.user.userinfo.sainsuranceCompanyList || [];
      var saCompanyCode = this.$store.state.user.userinfo.sainsuranceCompanyList[0].insuranceCompanyCode || '';

      if (userRoleType === 'subAssured') {
        list = saList;
        companyCode = saCompanyCode;
      } else {
        list = list.concat(saList).filter(function (item, index, array) {
          return array.indexOf(item) === index;
        });
      }
    }

    this.get_select(list, companyCode); // 默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value;
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label;
    this.restaurants = this.loadAll();
  },
  methods: {
    /** 下载批单 */
    downloadEndorsement: function downloadEndorsement(data) {
      var policyUrl = data.policyUrl;
      policyUrl = policyUrl.substring(0, policyUrl.indexOf('=') + 1) + data.endorseNo;
      console.log(policyUrl);
      window.open(policyUrl);
    },
    //   get_OrganizationId(val) {//val 后台返回的id
    //     let arr = [];//定义一个空数组
    //     let oiptions = this.options;//拿到的所有数据集合（树状）
    //     this.$nextTick(() => {
    //       if (!oiptions && oiptions.legth <= 0) return;
    //       fun(oiptions); //调用封装好的回显函数
    //       let out=false;//定义一个标识（是否找到对应的id）
    //       function fun(childrenArr) {  //封装的回显函数
    //         let bg=0; //定义一个标杆（标识循环到当前数组的第几条）
    //         for (let item of childrenArr) {
    //           if (item.id === val) {//判断所在数组（层级），是否有与之匹配的id
    //             arr.push(item.id);//存在则返回其id
    //             out=true;//存在就将标识设置为true
    //             return;//递归出口（出口1）
    //           } else if (//判断id不匹配的层级是否具有下级目录（children）
    //             item.organizationSelectionAllResponses &&
    //             item.organizationSelectionAllResponses.length > 0
    //           ) {
    //             arr.push(item.id);
    //             fun(item.organizationSelectionAllResponses);//存在下级目录就将下一级目录回调
    //           }
    //           bg++;
    //           if(out) return//如果找到对应的id 就执行返回 （出口2）
    //           if(bg===childrenArr.length && arr&&arr.length>0){
    //             arr=[];//如果在最后一个数组对象都没有找到对应ID 那么就清空数组
    //           }
    //         }
    //       }
    //       this.Dialogform.DeptId = arr;//最后将其赋值给默认选中数组
    //     });
    //   },
    // },
    getInsuredNameCheck: function getInsuredNameCheck() {
      var _this = this;

      var params = {
        'codeType': 'insuredName'
      };
      getBaseCodeByCodeType(params).then(function (res) {
        debugger;

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.label = res[i].codeCode;
          obj.value = res[i].codeCname;

          _this.insuredNameCheck.push(obj);
        }
      });
    },
    goDetail: function goDetail(e) {
      this.getLeafKeys(e);
    },
    getLeafKeys: function getLeafKeys(e) {
      var _this2 = this;

      this.agentOptions.forEach(function (item) {
        item.children.forEach(function (itm) {
          itm.children.forEach(function (it) {
            if (it.children == [] || it.children == null) {
              if (it.address == e[2]) {
                _this2.newList = it;
              }
            } else {
              it.children.forEach(function (i) {
                if (i.address == e[3]) {
                  _this2.newList = i;
                }
              });
            }
          });
        });
      });
      this.payAgent.agentName = this.newList.agentName;
      this.payAgent.email = this.newList.email;
      this.payAgent.telephoneNumber = this.newList.telephoneNumber;
      this.payAgent.facsimileNumber = this.newList.facsimileNumber; //this.payAgent.selectedAgent = this.newList.address
    },
    isShowDialog: function isShowDialog(type, scope) {
      this.getAddressData(scope.row.insuranceCompanyCode);
      console.log(scope.row.insuranceCompanyCode);
      this.lists = scope.row;
      console.log(type);

      if (type == '4') {
        this.agentShow = false;
      } else if (type == '6') {
        this.get_data('6', this.lists.proposalNo, this.lists.protocolNo, this.lists.autonuclearType, this.lists.documentType, this.agentPrint);
      } else {
        this.agentShow = true;
      }
    },
    getAddressData: function getAddressData(insurancecompanyCode) {
      var _this3 = this;

      var params = {
        'insuranceCompanyCode': insurancecompanyCode
      };
      queryliPeiData(params).then(function (res) {
        // console.log(res, '==res')
        _this3.agentOptions = res; // console.log(JSON.stringify(this.agentOptions))
      });
    },
    // 申请ci凭证
    applyCi: function applyCi() {
      this.agentShow = true;
    },
    cancelAgent: function cancelAgent(formName) {
      var _this4 = this;

      this.agentShow = false;
      this.$nextTick(function () {
        _this4.$refs[formName].clearValidate();
      }); // this.selectedAgent = ''
    },
    saveAgent: function saveAgent(formName) {
      var _this5 = this;

      this.agentShow = true;
      this.$refs[formName].validate(function (valid) {
        console.log(valid);

        if (valid) {
          _this5.agentShow = false;
          var len = _this5.payAgent.selectedAgent.length - 1;
          var agent = _this5.payAgent.selectedAgent[len];
          var reg = new RegExp(',', 'g'); //g代表全部

          _this5.payAgent.email = _this5.payAgent.email.replace(reg, '');
          _this5.address_list = JSON.parse(JSON.stringify(_this5.payAgent.agentName + '<br/>' + agent + '<br/>' + 'TEL:' + _this5.payAgent.telephoneNumber + '<br/>' + 'FAX:' + _this5.payAgent.facsimileNumber + '<br/>' + 'EMAIL:' + _this5.payAgent.email));

          if (_this5.previewFlag == true) {
            _this5.get_data('6', _this5.lists.proposalNo, _this5.lists.protocolNo, _this5.lists.autonuclearType, _this5.lists.documentType, _this5.agentPrint);

            _this5.previewFlag = false;
          } else {
            if (_this5.address_list != null && _this5.address_list != '' && _this5.address_list != undefined) {
              _this5.get_data('2', _this5.lists.proposalNo, _this5.lists.protocolNo, _this5.lists.autonuclearType, _this5.lists.documentType);
            }
          }
        }
      });
    },
    getPath: function getPath() {
      this.Init_get();
    },
    // 初始化
    Init_get: function Init_get() {
      var _this6 = this;

      var data = this.inForm;
      this.loading = true;
      data.insuranceCompanyName = this.inForm.insuranceCompanyName;
      data.insuranceCompanyCode = this.inForm.insuranceCompanyCode;
      data.companyName = this.inForm.companyName;
      data.companyCode = this.inForm.companyCode;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize; // console.log(data)

      proposalQueryList(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode')); // console.log(orgCode,"信用代码")

        if (res.content != null) {
          for (var i = 0; i < res.content.length; i++) {
            // 如果查询数据的投保人不是当前登录用户-usertype==0，identifyNumber是投保人的orgcode
            // 场景1，查询的数据是自己作为投保人的数据:register:判断投保人是否是自己，相同则usertype=1 ，不同则0
            // 场景2，查询的数据是自己作为被保险人的数据:subAssured:判断被保险人是否是自己，不是则禁用user_type = '0'
            if (res.content[i].queryType != null) {
              var queryType = res.content[i].queryType;

              if (queryType === 'register') {
                if (res.content[i].identifyNumber != null) {
                  if (orgCode !== res.content[i].identifyNumber) {
                    console.log(res.content[i].identifyNumber, i);
                    res.content[i].user_type = '0';
                    _this6.permissionsbtn = false;
                  } else {
                    res.content[i].user_type = '1';
                    _this6.permissionsbtn = true;
                  }
                } else {
                  res.content[i].user_type = '0';
                  _this6.permissionsbtn = false;
                }
              } else if (queryType === 'subAssured') {
                // 查出的数据都是自己为被保险人的数据，无需额外判断
                res.content[i].user_type = '1';
                _this6.permissionsbtn = true;
              } else {
                res.content[i].user_type = '0';
                _this6.permissionsbtn = false;
              }
            } else {
              res.content[i].user_type = '0';
              _this6.permissionsbtn = false;
            }
          }
        }

        _this6.tableData = res.content;
        _this6.total = res.totalCount;
        _this6.loading = false; // 判断是否已生成电子保单 / CI凭证

        if (_this6.tableData) {
          for (var i = 0; i < _this6.tableData.length; i++) {
            if (_this6.tableData[i].documentFlag == '1') {
              if (_this6.tableData[i].documentType == '4') {
                _this6.tableData[i].documentType = '已生成电子保单';
              } else if (_this6.tableData[i].documentType == '5') {
                _this6.tableData[i].documentType = '已生成CI凭证';
              } else if (_this6.tableData[i].documentType == '1') {
                _this6.tableData[i].documentType = '申请电子保单';
              } else if (_this6.tableData[i].documentType == '2') {
                _this6.tableData[i].documentType = '申请CI凭证';
              }
            } else {
              _this6.tableData[i].documentType = '';
            } // 判断为日元或非日元时展示保额保费


            if (_this6.tableData[i].amount != null) {
              if (_this6.tableData[i].currencyName == '日本元') {
                _this6.tableData[i].amount = toThousands(Math.round(_this6.tableData[i].amount));
              } else {
                _this6.tableData[i].amount = num3_type_fun(_this6.tableData[i].amount);
              }
            }

            if (_this6.tableData[i].premium != null) {
              if (_this6.tableData[i].currencyName == '日本元') {
                _this6.tableData[i].premium = toThousands(Math.round(_this6.tableData[i].premium));
              } else {
                _this6.tableData[i].premium = num3_type_fun(_this6.tableData[i].premium);
              }
            } // if(this.tableData[i].currencyName == '日本元'){
            // 	this.tableData[i].amount = toThousands(Math.round(this.tableData[i].amount))
            // 	this.tableData[i].premium = toThousands(Math.round(this.tableData[i].premium))
            // }else{
            // 	this.tableData[i].amount = num3_type_fun(this.tableData[i].amount)
            // 	this.tableData[i].premium = num3_type_fun(this.tableData[i].premium)
            // }

          }
        }
      });
    },
    // 投保单导出
    listCargoInsuranceDc: function listCargoInsuranceDc() {
      var _this7 = this;

      var proposalNoList = [];
      var multipleTablelist = this.$refs.multipleTable.selection;

      for (var i = 0; i < multipleTablelist.length; i++) {
        proposalNoList.push(multipleTablelist[i].proposalNo);
      }

      var data = {
        //投保申请单号
        proposalNo: this.inForm.proposalNo || '',
        //保险公司
        insuranceCompanyCode: this.inForm.insuranceCompanyCode || '',
        //分支机构
        companyCode: this.inForm.companyCode || '',
        //产品名称
        riskCode: this.inForm.riskCode || '',
        riskName: this.inForm.riskName || '',
        //起保日期起
        startDate: this.inForm.startDate || '',
        //起保日期到
        endDate: this.inForm.endDate || '',
        //被保险人名称
        insuredName: this.inForm.insuredName || '',
        //投保单状态
        proposalStatus: this.inForm.proposalStatus || '',
        //OP协议号
        protocolNo: this.inForm.protocolNo || '',
        //报关单号
        customsListNo: this.inForm.customsListNo || '',
        //单证状态
        documentType: this.inForm.documentType || '',
        //询价单号
        businessNo: this.inForm.businessNo || '',
        //投保单来源
        customFlag: this.inForm.customFlag || '',
        //发票号
        invoicNo: this.inForm.invoicNo || '',
        //保单号
        policyNo: this.inForm.policyNo || '',
        //投保人名称
        applicantName: this.inForm.applicantName || '',
        //投保单id
        proposalNoList: proposalNoList
      };
      countCargoInsuranceDc(data).then(function (res1) {
        if (res1.resultCode === '0000') {
          if (res1.resultObj > 1000) {
            _this7.$message({
              message: '导出数据数量大于1000条,不允许导出，请改变查询条件后重新导出',
              type: 'error'
            });
          } else if (res1.resultObj == 0) {
            _this7.$message({
              message: '导出数据数量为0,不允许导出，请改变查询条件后重新导出',
              type: 'error'
            });
          } else {
            cargoInsuranceDc(data).then(function (res) {
              var blob = new Blob([res], {
                type: 'application/vnd.ms-excel'
              }); // 兼容ie

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, '投保清单.xlsx');
              } else {
                var url = window.URL.createObjectURL(blob);
                var link = document.createElement('a'); // 创建a标签

                link.href = url;
                link.download = '投保清单.xlsx'; // 重命名文件

                link.click();
                window.URL.revokeObjectURL(url); // 释放内存
              }
            });
          }
        }
      });
    },
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label; // 查询保险公司下的分支机构

      this.companyqueryAll_fun(val);
      this.riskqueryAll_fun(val);
    },
    // 分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    // 产品名称 --险种
    riskCode_ch: function riskCode_ch(val) {
      var obj = {};
      obj = this.options2.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.riskName = obj.label;
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this8 = this;

      var data = {}; //  去除首尾空格

      this.inForm.proposalNo = this.inForm.proposalNo.trim();
      this.inForm.insuredName = this.inForm.insuredName.trim();
      this.inForm.protocolNo = this.inForm.protocolNo.trim();
      this.inForm.customsListNo = this.inForm.customsListNo.trim();
      this.inForm.applicantName = this.inForm.applicantName.trim();

      if (this.inForm.startDate && this.inForm.endDate) {
        if (this.inForm.startDate > this.inForm.endDate) {
          this.$message({
            type: 'warning',
            message: '起保起期不能晚于起保止期'
          });
          return false;
        } else {
          this.$refs[formName].validate(function (valid) {
            if (valid) {
              _this8.pageNo = 1;

              _this8.Init_get();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        }
      } else {
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this8.pageNo = 1;

            _this8.Init_get();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        proposalNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        companyCode: '',
        companyName: '',
        riskCode: '',
        riskName: '',
        startDate: '',
        endDate: '',
        insuredName: '',
        addRecordFlag: '',
        proposalStatus: '',
        protocolNo: '',
        customsListNo: '',
        customFlag: '',
        businessNo: '',
        policyNo: '',
        applicantName: ''
      }; // //清空分支机构

      this.options_companyName = [];
      this.options2 = [];
    },
    // 删除
    del_but: function del_but(row) {
      var _this9 = this;

      this.$confirm('此操作将永久删除该申请单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          proposalNo: row.row.proposalNo
        };
        deleteByProposalNo_fun(data).then(function (res) {
          if (res.rtnCode == '0000') {
            _this9.$message({
              message: '删除成功',
              type: 'success'
            });

            _this9.Init_get();
          } else {
            _this9.$message({
              message: res.rtnMsg,
              type: 'error'
            });

            _this9.Init_get();
          }
        });
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      console.log(row); //				this.tableData.splice(row.$index, 1)
    },
    // 撤回修改
    back_but: function back_but(row) {
      var _this10 = this;

      this.$confirm('是否确定撤回修改此投保申请单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          proposalNo: row.row.proposalNo
        };
        backByProposalNo_fun(data).then(function (res) {
          if (res.rtnCode == '0000') {
            _this10.$message({
              message: '撤回成功',
              type: 'success'
            });

            _this10.Init_get();
          }
        });
      }).catch(function () {
        _this10.$message({
          type: 'info',
          message: '已取消撤回'
        });
      });
      console.log(row); //				this.tableData.splice(row.$index, 1)
    },
    // 作废
    toVoid_but: function toVoid_but(row) {
      var _this11 = this;

      this.$confirm('请确认是否要作废该申请单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          proposalNo: row.row.proposalNo,
          protocolNo: row.row.protocolNo
        };
        proposalToVoid_fun(data).then(function (res) {
          if (res.rtnCode == '0000') {
            _this11.$message({
              message: '作废成功',
              type: 'success'
            });

            _this11.Init_get();
          }
        });
      }).catch(function () {
        _this11.$message({
          type: 'info',
          message: '已取消作废'
        });
      });
      console.log(row); //				this.tableData.splice(row.$index, 1)
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        'value': '三全鲜食（北新泾店）',
        'address': '长宁区新渔路144号'
      }, {
        'value': 'Hot honey 首尔炸鸡（仙霞路）',
        'address': '上海市长宁区淞虹路661号'
      }, {
        'value': '新旺角茶餐厅',
        'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'
      }];
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
    },
    // 查看 ------ 编辑
    view_but: function view_but(type, row) {
      var _this12 = this;

      console.log(row);
      var params = {
        type: type,
        insurancecompanyCode: row.row.insuranceCompanyCode,
        protocolNo: row.row.protocolNo,
        riskCode: row.row.riskCode,
        riskName: row.row.riskName,
        proposalNo: row.row.proposalNo,
        queryType: row.row.queryType,
        createBy: row.row.createBy
      };
      console.log(params.insurancecompanyCode);
      /*this.$router.push({
         path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`
      })*/

      console.log(type);

      if (type == 'opcopy') {
        //YCKK-1393 贸易平台外航(CMAR和CEXP)投保时增加提示-俄罗斯产原油(HS CODE 270900)及石油产品(HS CODE 2710)为禁止承保货物 2023-02-27
        params.riskCode;

        if (params.riskCode == "CEXP" || params.riskCode == "CMAR") {
          var message = "<p style=\"word-wrap:break-word;\">\u4FC4\u7F57\u65AF\u4EA7\u539F\u6CB9(HS CODE 270900)\u53CA\u77F3\u6CB9\u4EA7\u54C1(HS CODE 2710)\u4E3A\u7981\u6B62\u627F\u4FDD\u8D27\u7269\u3002(This policy does not cover Russian crude oil and Russian petrochemical products falling under HS code 2709 00 and HS code 2710.) \u8BF7\u4E86\u89E3\u3002\n                            <br><br>\u507F\u4ED8\u80FD\u529B\u4FE1\u606F\u516C\u5F00\u62AB\u9732\uFF1A\n                            <br>\u8BF7\u901A\u8FC7\u5982\u4E0B\u5B98\u7F51\u94FE\u63A5\uFF0C\u5728\u201C\u4E13\u9879\u4FE1\u606F\u201D\u62AB\u9732\u680F\u4E2D\u83B7\u53D6\u672C\u516C\u53F8\u6700\u65B0\u507F\u4ED8\u80FD\u529B\u76F8\u5173\u4FE1\u606F\u3002\n                            <br><a href=\"https://www.ms-ins.com.cn/BaseInfo.html#base4\" target=\"_blank\" style=\"text-decoration: underline;\">https://www.ms-ins.com.cn/BaseInfo.html#base4</a>\n                            </p>";
          this.$confirm(message, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '已了解',
            closeOnClickModal: false,
            cancelButtonClass: 'custom-button',
            customClass: 'custom-button-frame',
            callback: function callback(action) {
              console.log('已了解'); //无报关单

              _this12.$router.push({
                name: 'insuranceentry1',
                params: params
              });
            }
          });
        } else if (params.riskCode == "CINL") {
          var _message = "<p style=\"word-wrap:break-word;\">\n                            \u507F\u4ED8\u80FD\u529B\u4FE1\u606F\u516C\u5F00\u62AB\u9732\uFF1A\n                            <br>\u8BF7\u901A\u8FC7\u5982\u4E0B\u5B98\u7F51\u94FE\u63A5\uFF0C\u5728\u201C\u4E13\u9879\u4FE1\u606F\u201D\u62AB\u9732\u680F\u4E2D\u83B7\u53D6\u672C\u516C\u53F8\u6700\u65B0\u507F\u4ED8\u80FD\u529B\u76F8\u5173\u4FE1\u606F\u3002\n\n                            <br><a href=\"https://www.ms-ins.com.cn/BaseInfo.html#base4\" target=\"_blank\" style=\"text-decoration: underline;\">https://www.ms-ins.com.cn/BaseInfo.html#base4</a>\n                            </p>";
          this.$confirm(_message, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '已了解',
            closeOnClickModal: false,
            cancelButtonClass: 'custom-button',
            customClass: 'custom-button-frame',
            callback: function callback(action) {
              console.log('已了解'); //无报关单

              _this12.$router.push({
                name: 'insuranceentry1',
                params: params
              });
            }
          });
        } else {
          //无报关单
          this.$router.push({
            name: 'insuranceentry1',
            params: params
          });
        }
      } else {
        if (row.row.othFlag != undefined && 'customFlag' == row.row.othFlag) {
          //报关单
          this.$router.push({
            name: 'insuranceentry2',
            params: params
          });
        } else if (row.row.othFlag != undefined && 'autoCustomFlag' == row.row.othFlag) {
          //报关单自动投保
          this.$router.push({
            name: 'insuranceentry3',
            params: params
          });
        } else {
          //无报关单
          this.$router.push({
            name: 'insuranceentry1',
            params: params
          });
        }
      }
    },
    //单证注销
    document_LogOut: function document_LogOut(val) {
      var _this13 = this;

      console.log(val);
      this.loading = true; //scope.row.documentType == '已生成CI凭证' scope.row.documentType == '已生成电子保单'

      if (val.documentType == '已生成CI凭证') {
        var now = new Date();
        var startDate = new Date(val.startDate);

        if (now >= startDate) {
          this.loading = false;
          this.isOrNotCI = true; // 当前时间 ≥ 起保日期，弹出退保原因选择框
          // 起保日期已到，弹出退保信息填写框

          this.currentRow = val;
          this.refundDialogVisible = true;
        } else {
          this.$confirm('请确认是否要取消该CI凭证', '提示', {
            confirmButtonText: '确认注销',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var data = {
              policyNo: val.policyNo,
              proposalNo: val.proposalNo,
              protocolNo: val.protocolNo,
              eEndorseFlag: '2',
              manualSelfNucleation: '0'
            };
            documentLogOut_fun(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'success'
                });

                _this13.Init_get();
              } else if (res.resultCode == '9999') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'error'
                });
              } else if (res.resultCode == '0001') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'error'
                });
              }

              _this13.loading = false;
            });
          }).catch(function () {
            _this13.$message({
              type: 'info',
              message: '已取消单证注销'
            });

            _this13.loading = false;
          });
        }
      }

      if (val.documentType == '已生成电子保单') {
        var _now = new Date();

        var _startDate = new Date(val.startDate);

        if (_now >= _startDate) {
          this.loading = false;
          this.isOrNotCI = false; // 当前时间 ≥ 起保日期，弹出退保原因选择框
          // 起保日期已到，弹出退保信息填写框

          this.currentRow = val;
          this.refundDialogVisible = true;
        } else {
          this.loading = true; // 当前时间 < 起保日期，走原来的取消逻辑

          this.$confirm('请确认是否要取消该电子保单', '提示', {
            confirmButtonText: '确认注销',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var data = {
              policyNo: val.policyNo,
              proposalNo: val.proposalNo,
              protocolNo: val.protocolNo,
              eEndorseFlag: '2',
              manualSelfNucleation: '0'
            };
            documentLogOut_fun(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'success'
                });

                _this13.Init_get();
              } else if (res.resultCode == '9999') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'error'
                });
              } else if (res.resultCode == '0001') {
                _this13.$message({
                  message: res.resultMess,
                  type: 'error'
                });
              }

              _this13.loading = false;
            });
          }).catch(function () {
            _this13.$message({
              type: 'info',
              message: '已取消单证注销'
            });

            _this13.loading = false;
          });
        }
      }
    },
    correct_info: function correct_info(data) {
      var _this14 = this;

      this.loading = true;
      var paramsData = {
        policyNo: data.policyNo,
        insuranceCompanyCode: data.insuranceCompanyCode,
        proposalNo: data.proposalNo
      };
      correctRecordQuery(paramsData).then(function (res) {
        if (res.resultCode == '0000') {
          _this14.endorseDataApplyInfo = res.correctRecordList.slice(0, 1);

          if (_this14.endorseDataApplyInfo[0].reasonCode == null) {
            _this14.endorseDataApplyInfo = [];
          }

          _this14.endorseData = res.correctRecordList.slice(1);
          _this14.dialogVisible = true;
          var now = new Date();
          var startDate = new Date(data.startDate);

          if (now >= startDate) {
            _this14.checkRefundDialogVisible = true;
            _this14.showFooterBtn = false;
          }

          _this14.$message({
            message: res.resultMsg,
            type: 'success'
          });
        } else if (res.resultCode == '9999') {
          _this14.endorseDataApplyInfo = [];
          _this14.endorseData = [];

          _this14.$message({
            message: res.resultMsg,
            type: 'error'
          });
        }

        _this14.loading = false;
      });
    },
    // 新增
    add_but: function add_but(type) {
      // this.$router.push({
      // 	name: 'policyentry',
      // 	params: {
      // 		type: type,
      // 		proposalNo: ''
      // 	}
      // });
      this.$router.push({
        path: "/agreemanagement/policyentry"
      });
    },
    // 申请电子保单 -- 申请IC凭证 --单证预览
    apply_but: function apply_but(type, scope, agentPrint) {
      var _this15 = this;

      // return
      var list = scope.row; // console.log("00000000",list)
      // const address_a = JSON.parse(sessionStorage.getItem('newAdress'))
      // console.log(address_a, '123')
      //点击申请电子保单初始化

      this.doPolicy1 = 0;
      this.doPolicy2 = 0;
      this.doPolicyCount = Date.now();

      if (type == '6') {} else {
        if (list.insurancecompanyCode == 'IC0009') {
          setTimeout(this.doPolicyTimer(type, list.proposalNo, list.autonuclearType), 20000);
        }
      }

      console.log(list.autonuclearType);
      var insuredNameCheckFlag = false;

      if (type === '2') {
        if (scope.row.isUpdateInsuredName === '1') {
          var insuredName = scope.row.insuredName;

          if (this.insuredNameCheck.length <= 0) {
            console.log('被保险人名称校验异常');
          }

          for (var i = 0; i < this.insuredNameCheck.length; i++) {
            var codeCname = this.insuredNameCheck[i].value;

            if (insuredName.includes(codeCname)) {
              insuredNameCheckFlag = true;
              break;
            }
          }
        }
      }

      if (insuredNameCheckFlag) {
        this.$confirm('被保险人应为货主，本单为承运人，请确认被保险人是否有货物所有权。如被保险人无货物所有权可能导致出险后无法理赔，请了解。', '提示', {
          confirmButtonText: '确认有货权',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this15.get_data(type, list.proposalNo, list.protocolNo, list.autonuclearType, list.documentType, agentPrint);
        }).catch(function () {
          _this15.forbidFastClickFlag = false;
        });
      } else {
        this.get_data(type, list.proposalNo, list.protocolNo, list.autonuclearType, list.documentType, agentPrint);
      }
    },
    // 批量申报确认
    apply_but_s: function apply_but_s(type) {
      console.log('获取到选中的值------', this.$refs.multipleTable.selection); // console.log(type)

      var tablelist = [];
      var multipleTablelist = this.$refs.multipleTable.selection;

      if (multipleTablelist.length > 1) {
        var Whether = true;
        var agreement = true;

        for (var i = 0; i < multipleTablelist.length; i++) {
          if (multipleTablelist[i].proposalStatus != '3') {
            Whether = false;
            break;
          } else {
            tablelist.push(multipleTablelist[i]);
          }
        }

        if (Whether == false) {
          this.$message({
            message: '只有已提交状态才能进行批量申报',
            type: 'warning'
          });
        } else {
          for (var j = 0; j < tablelist.length; j++) {
            if (tablelist[j].protocolNo != tablelist[j + 1].protocolNo) {
              agreement = false;
              break;
            } else {
              agreement = true;
              break;
            }
          }

          console.log(agreement);

          if (agreement == false) {
            this.$message({
              message: '当前选择的申请单协议号不同，请重新选择',
              type: 'warning'
            });
          } else {
            this.batchDeclaration(type, tablelist);
          }
        }
      } else if (multipleTablelist.length = 1) {
        for (var i = 0; i < multipleTablelist.length; i++) {
          if (multipleTablelist[i].proposalStatus != '3') {
            Whether = false;
            break;
          } else {
            tablelist.push(multipleTablelist[i]);
          }
        }

        if (Whether == false) {
          this.$message({
            message: '只有已提交状态才能进行批量申报',
            type: 'warning'
          });
        } else {
          this.batchDeclaration(type, tablelist);
        }
      } else {
        this.$message({
          message: '请先选择一条信息进行操作',
          type: 'warning'
        });
      }
    },
    download: function download(self, data) {
      var params = {
        proposalNo: data.proposalNo
      };
      console.log(data.insuranceCompanyCode);

      if ('IC0029' == data.insuranceCompanyCode) {
        //对接平安
        this.$router.push({
          name: 'downloadPolicy',
          params: params
        });
      } else {
        console.log(data.policyUrl);
        window.open(data.policyUrl);
      }
    },
    //申请电子保单 proposalNo
    apply_butNew: function apply_butNew(type, scope) {
      var _this16 = this;

      debugger;
      console.log(scope); //保费

      var sumPremium = scope.row.premium; //投保单号

      var proposalNo = scope.row.proposalNo; //最低保费

      var limitMiniPremium = scope.row.limitminipremium; //币种

      var remiumCurrency = scope.row.currencyName; //产品名称

      var riskName = scope.row.riskName;

      if (remiumCurrency == '人民币元 - CNY') {
        remiumCurrency = remiumCurrency.substring(0, 3);
      }

      remiumCurrency = remiumCurrency.split("-");
      sumPremium = sumPremium.replaceAll(',', '');

      if (Number(sumPremium) <= Number(limitMiniPremium)) {
        if (riskName == '陆上运输货物保险') {
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + limitMiniPremium + '元，本单将按最低保费收取并附加 "CAG133-三井住友附加最低保费保险条款"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this16.agentPrintShow = true;
            _this16.agentPrintTitle = '电子保单';
            _this16.agentPrint['type'] = type;
            _this16.agentPrint['scope'] = scope;
            var data = {
              //产品名称
              riskName: riskName,
              //投保单号
              proposalNo: proposalNo
            };
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this16.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this16.$message({
                  message: '保存条款失败',
                  type: 'error'
                });
              }
            });
          }).catch(function () {});
        } else if (riskName == '进口货物运输保险') {
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + limitMiniPremium + '元 ，本单将按最低保费收取并附加 "CAG133E-MINIMUM PREMIUM CLAUSE"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this16.agentPrintShow = true;
            _this16.agentPrintTitle = '电子保单';
            _this16.agentPrint['type'] = type;
            _this16.agentPrint['scope'] = scope;
            var data = {
              //产品名称
              riskName: riskName,
              //投保单号
              proposalNo: proposalNo
            };
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this16.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this16.$message({
                  message: '保存条款失败',
                  type: 'error'
                });

                return;
              }
            });
          }).catch(function () {});
        } else if (riskName == '出口货物运输保险') {
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + limitMiniPremium + '元 ，本单将按最低保费收取并附加 "CAG133E-MINIMUM PREMIUM CLAUSE"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this16.agentPrintShow = true;
            _this16.agentPrintTitle = '电子保单';
            _this16.agentPrint['type'] = type;
            _this16.agentPrint['scope'] = scope;
            var data = {
              //产品名称
              riskName: riskName,
              //投保单号
              proposalNo: proposalNo
            };
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this16.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this16.$message({
                  message: '保存条款失败',
                  type: 'error'
                });

                return;
              }
            });
          }).catch(function () {});
        }
      } else {
        this.agentPrintShow = true;
        this.agentPrintTitle = '电子保单';
        this.agentPrint['type'] = type;
        this.agentPrint['scope'] = scope;
      }
    },
    apply_butNewCI: function apply_butNewCI(type, scope) {
      this.agentPrintShow = true;
      this.agentPrintTitle = 'CI凭证';
      this.agentPrint['type'] = type;
      this.agentPrint['scope'] = scope;
    },
    // 申请电子保单 ci凭证
    cancelPrintAgent: function cancelPrintAgent() {
      this.agentPrintShow = false;
      this.$refs['agentPrint'].resetFields();
    },
    savePrintAgent: function savePrintAgent() {
      var _this17 = this;

      this.forbidFastClickFlag = true;
      this.$refs['agentPrint'].validate(function (valid) {
        if (valid) {
          _this17.agentPrintShow = false;

          if (_this17.agentPrintTitle === '电子保单' || _this17.agentPrintTitle === 'CI凭证') {
            _this17.apply_but(_this17.agentPrint.type, _this17.agentPrint.scope, _this17.agentPrint);
          }

          _this17.$refs['agentPrint'].resetFields();
        }
      });
    },
    batchDeclaration: function batchDeclaration(type, list) {
      var _this18 = this;

      this.loading = true;
      var data = {
        reqProposalCallDtoList: []
      };

      for (var i = 0; i < list.length; i++) {
        data.reqProposalCallDtoList.push({
          proposalNo: list[i].proposalNo,
          protocolNo: list[i].protocolNo,
          type: type
        });
      } // console.log(data)


      proposalCallWriteBack_fun(data).then(function (res) {
        if (res.rtnCode == '0000') {
          // this.$message({
          // 	message: '申报确认，提交成功，请在投保单/保单查询菜单执行后续操作',
          // 	type: 'success'
          // });
          _this18.$alert('<p>批改申请单号：' + res.businessNo + '<p>申报确认，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this18.Init_get();
            }
          });
        } else {
          // this.$message({
          // 	message: '申报确认，提交失败',
          // 	type: 'warning'
          // });
          _this18.$alert('<p>' + res.data + '</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this18.Init_get();
            }
          });
        }

        _this18.loading = false;
      });
    },
    // 这是一个定时器
    doPolicyTimer: function doPolicyTimer(type, proposalNo, autonuclearType) {
      var _this19 = this;

      var doPolicyTimerId = setInterval(function () {
        var timeCount = Date.now();
        console.log("轮询" + timeCount);

        if (timeCount - _this19.doPolicyCount > 120000) {
          console.log("轮询结束--------2分钟超时关闭");
          clearInterval(doPolicyTimerId);

          _this19.$alert('<p>数据正在推送核心，请稍等片刻再查询投保单状态，投保单状态变更前请不要进行重复操作</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this19.Init_get();
            }
          });

          _this19.loading = false;
        } else {
          console.log("判断是否轮询");

          if (_this19.doPolicy1 == 0 && _this19.doPolicy2 == 0) {
            console.log("每隔5秒-------------------轮询接口调用开始");
            var data = {
              reqProposalCallDtoList: [{
                proposalNo: proposalNo,
                type: type
              }]
            };

            if (type == '1' || type == '2') {
              var typeStr1 = '电子保单';

              if (type == '2') {
                typeStr1 = 'CI凭证';
              }

              proposalCallBack_fun(data).then(function (res) {
                if (res.rtnCode == '0000') {
                  var businessNo = res.businessNo;

                  if (businessNo == null) {
                    businessNo = '';
                  }

                  if (autonuclearType == '1') {
                    _this19.$alert('<p>询价单号：' + businessNo + '</p><p>保单号：' + res.policyNo + '</p><p>申请' + typeStr1 + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this19.Init_get();
                      }
                    });
                  } else {
                    _this19.$alert('<p>询价单号：' + businessNo + '</p><p>申请' + typeStr1 + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this19.Init_get();
                      }
                    });
                  }

                  _this19.doPolicy2 = 1;
                  _this19.loading = false;
                } else if (res.rtnCode == '9999') {
                  console.log("没有结果继续轮询");
                }
              });
            }
          } else {
            console.log("判断不轮询-----------轮询结束--------状态变化关闭");
            clearInterval(doPolicyTimerId);
          }
        }
      }, 5000);
    },
    // 单个申请电子保单 / 申请凭证 /单证预览
    get_data: function get_data(type, proposalNo, protocolNo, autonuclearType, documentType, agentPrint) {
      var _this20 = this;

      console.log(agentPrint);
      this.loading = true; // const address_a = JSON.parse(sessionStorage.getItem('newAdress'))
      // console.log(address_a, '123')

      var data = {
        address: this.address_list,
        reqProposalCallDtoList: [{
          proposalNo: proposalNo,
          protocolNo: protocolNo,
          type: type
        }],
        originalAmount: agentPrint.originalAmount || '',
        copyAmount: agentPrint.copyAmount || ''
      };

      if (type === '1' || type === '2') {
        var typeStr = '';

        if (type === '1') {
          typeStr = '电子保单';
        } else if (type === '2') {
          typeStr = 'CI凭证';
        }

        if (documentType == '已生成CI凭证') {
          this.$alert('<p>已生成CI凭证，不允许再生成电子保单</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this20.Init_get();
            }
          });
          this.loading = false;
        } else {
          proposalCallWriteBack_fun(data).then(function (res) {
            _this20.forbidFastClickFlag = false;
            console.log("申请" + typeStr + "结果开始" + _this20.doPolicy2);

            if (_this20.doPolicy2 == 0) {
              console.log(res.rtnCode);

              if (res.rtnCode == '0000') {
                // this.$message({
                // 	message: '申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作',
                // 	type: 'success'
                // });
                if (autonuclearType == '1') {
                  var policyNoRes = res.policyNo;

                  if (policyNoRes === null || policyNoRes === undefined) {
                    policyNoRes = '';
                  }

                  _this20.$alert('<p>询价单号：' + res.businessNo + '</p><p>保单号：' + policyNoRes + '</p><p>申请' + typeStr + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: function callback(action) {
                      _this20.Init_get();
                    }
                  });
                } else {
                  _this20.$alert('<p>询价单号：' + res.businessNo + '</p><p>申请' + typeStr + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: function callback(action) {
                      _this20.Init_get();
                    }
                  });
                }
              } else if (res.rtnCode == '9999') {
                // this.$message({
                // 	message: '申请电子保单，提交失败',
                // 	type: 'warning'
                // });
                _this20.$alert('<p>' + res.data + '</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {
                    _this20.Init_get();
                  }
                });
              } else if (res.rtnCode == '0001') {
                _this20.$message({
                  message: '推送保险公司失败，请联系保险公司管理员！',
                  type: 'warning'
                });
              }

              console.log("------------------------");
              _this20.loading = false;
              _this20.doPolicy1 = 1;
            }
          });
        }
      }
      /*
      else if (type == '2') {
        proposalCallWriteBack_fun(data).then(res => {
          if (autonuclearType == '1') {
            if (res.rtnCode == '0000') {
              this.$alert('<p>申请CI凭证成功</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                  this.Init_get()
                }
              })
            } else if (res.rtnCode == '9999') {
              this.$alert('<p>申请CI凭证失败</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                  this.Init_get()
                }
              })
            }
          } else {
            this.$alert('<p>该记录不满足自核规则，需转小保单投保</p>', '', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              callback: action => {
                this.Init_get()
              }
            })
          }
          this.loading = false
        })
      }*/
      else if (type == '6') {
          //单证预览
          certificatePreview(data).then(function (res) {
            console.log("单证预览反参:" + res);
            console.log("单证预览反参:" + res.size + res.type);

            if (res.type == "application/pdf") {
              var binaryData = [];
              binaryData.push(res); //获取blob链接

              _this20.pdfUrl = window.URL.createObjectURL(new Blob(binaryData, {
                type: 'application/pdf'
              }));
              console.log(_this20.pdfUrl);
              window.open(_this20.pdfUrl);
              _this20.loading = false;
            } else {
              _this20.$alert('<p>单证预览失败，请联系管理员!</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this20.Init_get();
                }
              });
            }
          });
        } // this.loading = false

    },
    // ------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    // 保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      var _this21 = this;

      //				var plk = {
      //					label:"请选择",
      //					value:""
      //
      //				}
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};
        obj.value = list[i].insuranceCompanyCode;
        obj.label = list[i].insuranceCompanyName;

        if (!obj.value || !obj.label) {
          this.options_insuranceCompanyName = [];
        } else {
          this.options_insuranceCompanyName.push(obj);
        }
      }

      var data = {
        insuranceCompanyCode: code
      };
      getCompanyList(data).then(function (res) {
        _this21.options_insuranceCompanyName = [];

        for (var i = 0; i < res.length; i++) {
          console.log(res);
          var obj = {};
          obj.value = res[i].insuranceCompanyCode;
          obj.label = res[i].insuranceCompanyName;

          if (!obj.value || !obj.label) {
            _this21.options_insuranceCompanyName = [];
          } else {
            _this21.options_insuranceCompanyName.push(obj);
          }
        }
      });
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this22 = this;

      this.options_companyName = [];
      var data = {
        insuranceCompanyCode: code
      };
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this22.options_companyName.push(obj);
        }
      });
    },
    // 产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this23 = this;

      this.options2 = [];
      var data = {
        insuranceCompanyCode: code
      };
      getProductList(data).then(function (res) {
        _this23.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this23.options2.push(obj);
        }

        console.log(_this23.options2);
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    refundClose: function refundClose() {
      this.checkRefundDialogVisible = false;
    },
    submitRefund: function submitRefund() {
      var _this24 = this;

      var mask = this.$loading({
        lock: true,
        text: '正在提交退保，请稍候…',
        background: 'rgba(0,0,0,.7)'
      });

      if (!this.refundForm.reasonCode || !this.refundForm.reasonText || !this.refundForm.reappearPolicyNo) {
        mask.close();
        this.$message.warning('请完整填写所有必填项');
        return;
      }

      var data = {
        policyNo: this.currentRow.policyNo,
        proposalNo: this.currentRow.proposalNo,
        protocolNo: this.currentRow.protocolNo,
        eEndorseFlag: '2',
        reasonCode: this.refundForm.reasonCode,
        reasonText: this.refundForm.reasonText,
        reappearPolicyNo: this.refundForm.reappearPolicyNo,
        manualSelfNucleation: '1'
      };
      documentLogOut_fun(data).then(function (res) {
        if (res.resultCode === '0000') {
          _this24.$message.success(res.resultMess);

          _this24.Init_get();
        } else {
          _this24.$message.error(res.resultMess);
        }

        _this24.loading = false;
      }).finally(function () {
        _this24.refundDialogVisible = false;
        mask.close();
      });
    },

    /* 关闭弹窗时重置表单 */
    resetRefundForm: function resetRefundForm() {
      this.loading = false;
      this.refundForm = {
        reasonCode: '',
        reasonText: '',
        reappearPolicyNo: ''
      };
    },

    /* 根据时间展示按钮置为取消保单还是退保 */
    getCancelBtnText: function getCancelBtnText(row) {
      var now = new Date();
      var startDate = new Date(row.startDate);

      if (now >= startDate) {
        return '保单退保';
      } else {
        return '取消保单';
      }
    }
  }
};